import { render, staticRenderFns } from "./Alexandra.vue?vue&type=template&id=6c822bc2&scoped=true"
import script from "./Alexandra.vue?vue&type=script&lang=js"
export * from "./Alexandra.vue?vue&type=script&lang=js"
import style0 from "./Alexandra.vue?vue&type=style&index=0&id=6c822bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c822bc2",
  null
  
)

export default component.exports